import apiClient from './apiClient';

export const getRankingData = async () => {
  const { data } = await apiClient.get(`/ranking`);
  return data;
};
